import cn from "../../../../Utils/class-names.utils";
import SubscriptionIcon from "../../../icons/subscription-status/subscription.icon";
import styles from "./sections.module.scss";

type Variant = "converted" | "changed";

interface SubscriptionSectionProps {
  subscriptionName?: string;
  date?: string;
  variant?: Variant;
}

const SubscriptionSection = ({ subscriptionName, date, variant }: SubscriptionSectionProps) => {
  return (
    <div className="d-flex flex-column gap-8">
      <div className={cn(styles.subscriptionTag, {
        [styles.subscriptionTagConverted]: variant === "converted",
        [styles.subscriptionTagChanged]: variant === "changed",
      })}>
        <span className="f-12 line-height-18">{subscriptionName}</span>
      </div>
      <div className="d-flex align-items-center gap-8">
        <SubscriptionIcon />
        <span className="f-12 line-height-18 f-400 f-grey">
          Subscription Started {date}
        </span>
      </div>
    </div>
  );
};

export default SubscriptionSection;
